import React from 'react'
import { SelectInput } from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { ImageGrid, ImageGriditemBar, ImageGridImage } from '../../components/image-grid'
import { ListBase } from '../../components/base'

const PromotionBannerListFilter = [
  <SelectInput
    key={0}
    label={`${COMMON_FIELDS}.published.label`}
    source='is_published'
    choices={[
      { id: 'true', name: `${COMMON_FIELDS}.published.choices.true` },
      { id: 'false', name: `${COMMON_FIELDS}.published.choices.false` },
    ]}
  />,
]

const PromotionBannersList = (): JSX.Element => {
  return (
    <ListBase filters={PromotionBannerListFilter} sort={{ field: 'create_at', order: 'DESC' }}>
      <ImageGrid>
        <ImageGridImage source={'image.full_path'} />
        <ImageGriditemBar
          approvedSource={null}
          publishedSource='is_published'
          expiredSource='end_date'
          highlightSource={null}
        />
      </ImageGrid>
    </ListBase>
  )
}

export default PromotionBannersList
